"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_STATUS = void 0;
exports.TASK_STATUS = {
    NEW: 'NEW',
    PROCESSED: 'PROCESSED',
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    CANCELED: 'CANCELED'
};
//# sourceMappingURL=taskStatus.js.map